import React from 'react';
import { Box, Checkbox, IconButton, Typography } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import CustomTooltip from './CustomTooltip';

interface ListingSummaryAckProps {
  ackText: string;
  setAck: (value: boolean) => void;
  tooltip?: string;
}

const ListingSummaryAck: React.FC<ListingSummaryAckProps> = ({
  ackText,
  setAck,
  tooltip,
}) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
        }}
      >
        <Checkbox onChange={(e) => setAck(e.target.checked)} />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="body2">{ackText}</Typography>
        {Boolean(tooltip) && (
          <CustomTooltip
            title={
              <React.Fragment>
                <Typography variant="body2" fontWeight="bold">
                  Why am I seeing this?
                </Typography>
                <Typography variant="body2">{tooltip}</Typography>
              </React.Fragment>
            }
          >
            <IconButton>
              <HelpOutline
                data-testid="listing-summary-photos-tooltip"
                sx={{
                  fontSize: '20px',
                  color: 'grey.500',
                  '&:hover': {
                    color: 'grey.700',
                  },
                }}
              />
            </IconButton>
          </CustomTooltip>
        )}
      </Box>
    </Box>
  );
};

export default ListingSummaryAck;
